export interface KubernetesEventResource {
    FirstObservedTime: string;
    LastObservedTime: string;
    Count: number;
    Action: string;
    Reason: string;
    Note: string;
    ReportingController: string;
    ReportingInstance: string;
    Type: KubernetesEventType;
    Manifest: string;
}

export const AllKubernetesEventTypes = ["Normal", "Warning"];
type KubernetesEventTypeTuple = typeof AllKubernetesEventTypes;
export type KubernetesEventType = KubernetesEventTypeTuple[number];
